<div class="top-bar">
  <a class="logo" href="https://www.sync.com"><img *ngIf="page === 'not-found'" src="./assets/images/group-logo.svg" /></a>
  <sync-icon matTooltip="Help" name="help" />
</div>

<div class="content" [ngClass]="page" >
  <ng-container *ngIf="page === 'transfer-account'">
    <img class="logo" src="./assets/images/logo.svg" />

    <app-error
      *ngIf="errcode"
      [errcode]="errcode"
    />

    <ng-container *ngIf="spinner">
      <h1>Transfer account</h1>
      <sync-spinner />
      <p *ngIf="!isInviteChecked">Verifying your invite</p>
    </ng-container>

    <form *ngIf="transferAccountPage === 'invited'" (ngSubmit)="onClickAccept()">
      <h1>Transfer account</h1>
      <p>You have been invited by <b>{{inviter}}</b> to transfer your Sync account to their organization. </p>
      
      <h2>By accepting this invite, you agree to the following: </h2>
      
      <div class="terms">
        <ol>
          <li>Ownership of your account will be transferred to the organization.</li>
          <li>Your account will be upgraded to a Teams plan and inherit all Teams features.</li>
          <li>Your files, folders, shares, links and selective sync settings will remain intact.</li>
          <li>You will not be able to access your account across all platforms and syncing will stop until the transfer is complete.</li>
          <li>You will need to re-authorize Sync on your computers and devices when the transfer is complete.</li>
        </ol>
      </div>
      
      <sync-divider />
      <h2>Enter your Sync password</h2>
      
      <div class="fields">
        <sync-text-field
          class="email"
          [disabled]="true"
          label="Your email address"
          [value]="invitee"
          [caption]="true"
          captionHint="This email address was specified for the transfer. If you use a different email address, please contact the administrator to send a new invite to the correct email."
        />
        <sync-text-field
          inputType="password"
          label="Password"
          [(value)]="password"
        />
      </div>
      
      <div class="buttons">
        <sync-button
          type="outlined"
          label="Decline"
          [isLoading]="reaction === false && spinner"
          [onClick]="onClickDecline"
        />
      
        <sync-button
          nativeType="submit"
          type="filled"
          label="Accept"
          [isLoading]="reaction === true && spinner"
          [disabled]="!canAccept"
        />
      </div>
      
      <sync-divider />
      
      <p class="learn-more"><a href="https://www.sync.com/help/getting-started-with-pro-teams-plus/#bprotransferuser" target="_blank">Learn more</a> about account transfers</p>
    </form>

    <ng-container *ngIf="transferAccountPage === 'accepted'">
      <h1>We’re transferring your account!</h1>

      <p>Your account is being transferred to your organization. <b>{{inviter}}</b> will be notified that the transfer is occurring.</p>
      
      <h2>Some account restrictions while we’re transferring:</h2>

      <div class="restrictions">
        <div class="restriction">
          <img src="./assets/images/block-stop.svg" />
          <span class="title">You will not be able to sign into your account.</span>
          <span class="description">You will not be able to access your account across all platforms until your account transfer is complete.</span>
        </div>
        <div class="restriction">
          <img src="./assets/images/block-stop.svg" />
          <span class="title">Your desktop app will stop syncing.</span>
          <span class="description">After transferring, you will need to sign in again on the desktop app.</span>
        </div>
        <div class="restriction">
          <sync-icon name="clock" />
          <span class="title">Transferring may take a while.</span>
          <span class="description">This process may take up to a few hours to complete.</span>
        </div>
      </div>

      <p>You will be notified when transferring is complete!</p>
      <p>Before proceeding, ensure all your devices are running the latest version of the Sync desktop app. <a href="https://www.sync.com/install/" target="_blank">Install the latest version.</a></p>

      <sync-divider />
      
      <p class="learn-more"><a href="https://www.sync.com/help/getting-started-with-pro-teams-plus/#bprotransferuser" target="_blank">Learn more</a> about account transfers</p>
    </ng-container>

    <ng-container *ngIf="transferAccountPage === 'declined'">
      <h1>Declined invite</h1>
      <p>You have declined the invite to join the team.</p>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="page === 'not-found'">
    <img class="logo" src="./assets/images/lock.svg" />
    <h1>Invite cannot be found</h1>
    <span class="error-code">Error #1600</span>

    <p>There are three reasons this may have happened:</p>

    <ol class="reasons">
      <li>
        <span class="reason">You’ve already accepted or declined this invite.</span>
      </li>
      <li>
        <span class="reason">Your invite expired or was removed by the admin before you had a chance to act on it.</span>
        <span class="action">Please contact the admin to re-invite you. You will receive a new invitation link.</span>
      </li>
      <li>
        <span class="reason">The link you were provided contains an error or was modified by your email client.</span>
        <span class="action">Ensure the link was sent correctly and that the entire link was clickable in your email. You can always copy & paste the address into your browser.</span>
      </li>
    </ol>

    <sync-button
      class="back-to-sync"
      type="outlined"
      label="Back to Sync"
      routerLink="/"
    />
  </ng-container>

  <ng-container *ngIf="page === 'two-factor'">
    <img class="logo" src="./assets/images/logo.svg" />
    <h1>Enter 2FA code</h1>
    <p class="please-enter">Please enter your 2FA code received in your email or your linked authenticator app.</p>
    <sync-text-field label="2FA code" [(value)]="twofacode" />
    <sync-button
      label="Submit"
      class="submit"
      [onClick]="onClickAccept"
      [isLoading]="spinner"
      [disabled]="!twofacode"
    />

    <div class="qa">
      <div
        class="entry"
        [class.open]="questions['no-code']"
      >
        <span
          class="question"
          (click)="toggleQuestion('no-code')"
        >
          <sync-icon name="chevron-down" />
          I didn’t receive my 2FA code in my email
        </span>
        <div class="answer">
          <p>Codes are only sent by email to accounts with email-based 2FA enabled.</p>
          <p>If enabled, an email with your 2FA code should arrive in your inbox within 5 minutes. Please double check your junk or spam folders.</p>
          <p>If you haven't received an email after 5 minutes, then an incorrect username and password combination may be why you did not receive a 2FA code in your email. Try <a href="/login">signing in</a> again, or <a href="/forgot-password">resetting your password</a>.</p>
        </div>
      </div>
      <div
        class="entry"
        [class.open]="questions['no-authenticator']"
      >
        <span
          class="question"
          (click)="toggleQuestion('no-authenticator')"
        >
          <sync-icon name="chevron-down" />
          My authenticator app code is not working
        </span>
        <div class="answer">
          <p>Codes from an authenticator app will only work for an account currently linked to the application.</p>
          <p>If your account is already linked, then an incorrect username and password combination may be why your 2FA code is not working. Try <a href="/login">signing in</a> again, or <a href="/forgot-password">resetting your password</a>.</p>
        </div>
      </div>
    </div>
    <sync-divider />
    <p class="learn-more"><a href="https://www.sync.com/help/getting-started-with-pro-teams-plus/#bprotransferuser" target="_blank">Learn more</a> about account transfers</p>
  </ng-container>

  <div class="footer">
    <span class="copyright">Copyright © {{ year }} Sync.com, Inc.</span>
    <span class="links"><a href="https://www.sync.com/terms/" target="_blank">Terms of service</a> · <a href="https://www.sync.com/privacy/" target="_blank">Privacy policy</a> · <a href="https://www.sync.com/privacy-policy-gdpr/" target="_blank">GDPR</a></span>
  </div>
</div>
